import { ErrorHandler, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@env';
import { ApplicationInsightsService } from './application-insights.service';

@Injectable({
   providedIn: 'root',
})
export class ErrorHandlerService extends ErrorHandler {
   constructor(
      private applicationInsightsService: ApplicationInsightsService,
      private router: Router
   ) {
      super();
   }

   override handleError(error: Error): void {
      try {
         this.applicationInsightsService.logException(error, this.getExceptionContext());
         if (!environment.production || this.applicationInsightsService.isEnabled === false) {
            console.error('Unhandled error:', error);
         }
      } catch (logError) {
         if (!environment.production) {
            console.warn('Error logging to Application Insights failed:', logError);
         }
      }
   }

   private getExceptionContext(): { [key: string]: any } {
      let enrichedContext: { [key: string]: any } = {};
      try {
         const currentUrl = window?.location?.href;
         const onlineStatus = navigator?.onLine;
         const route = this.router?.url;

         enrichedContext = {
            url: currentUrl,
            route: route,
            online: onlineStatus,
         };
      } catch (logError) {
         //
      }

      return enrichedContext;
   }
}
